<template>
  <div>
    <HashHeader md5Hash/>
    <v-container>
      <v-row>
        <v-col cols="8">
          <v-textarea
            outlined
            name="input-10-6"
            label="Value"
            rows='8'
            v-model="value"
          ></v-textarea>
          <v-btn block color="primary" dark @click="handleConversion()">Hash</v-btn>
          <br/>
          <v-textarea
            outlined
            name="input-10-6"
            label="Hash"
            rows='8'
            v-model="hash"
          ></v-textarea>
        </v-col>
        <v-col cols="4">
          <p>Did you know?</p>
          <ul>
            <li>MD5 is a one way hash!</li>
            <li>MD5 Hash is used for verifying the data integrity!</li>
            <li>MD5 Hash is used for generating password hashes!</li>
            <li>MD5 Hash is used for verifying file changes!</li>
            <li>MD5 Hash will always be on 128 bit size!</li>
            <li>MD5 Hash is also called as message digest!</li>
            <li>Generated MD5 Hash cannot be de-hashed, It can only be broken through vulnerabilities!</li>
            <li>A string of any length can be converted into 128 bit data using MD5 Hashing algorithm!</li>
            <li>For a given string MD5 Hash will always be the same!</li>
          </ul>     
        </v-col>
      </v-row>
    </v-container> 
  </div>
</template>

<script>


export default {
  components: {
    HashHeader: () => import('./HashHeader.vue')   
  },
  data() {
    return {
      value: "",
      hash: "",
      name: "MD5 Hash"
    };
  },
  created () {
      document.title = "Online MD5 Hash - Encodify";
  },
  methods: {
    handleConversion() {
      var md5 = require("md5");
      this.hash = md5(this.value);
    }
  }
};
</script>
